var map = {
	"./Frame 57.svg": 73843,
	"./Newsletter.svg": 66415,
	"./SuperOps-logo-dark.svg": 39464,
	"./SuperOps-logo.svg": 82235,
	"./accordion/down-arrow.svg": 51763,
	"./angry.svg": 28573,
	"./arow-right.svg": 12452,
	"./arrow-down.svg": 95818,
	"./arrowLeftNew.svg": 55856,
	"./arrowRightNew.svg": 1353,
	"./arrowright.svg": 68921,
	"./atera_svg_1.svg": 86586,
	"./atera_svg_2.svg": 54697,
	"./atera_svg_3.svg": 66808,
	"./atera_svg_4.svg": 39639,
	"./attach-file-icon.svg": 48310,
	"./auth-blog-icon.svg": 11417,
	"./badge-testimonial/quotesPurple.svg": 45065,
	"./badge-testimonial/quotes_box_down.svg": 38412,
	"./badge-testimonial/quotes_box_up.svg": 75207,
	"./badge-testimonial/redLineV2.svg": 96919,
	"./benefitsSideArrow-1.svg": 19600,
	"./benefitsSideArrow-2.svg": 76643,
	"./block/blueCurveWire.svg": 93374,
	"./block/blueSBend.svg": 64662,
	"./block/curvedBend.svg": 72742,
	"./block/downArrowRed.svg": 94908,
	"./block/greenScribble.svg": 97149,
	"./block/lightGreenScribble.svg": 82025,
	"./block/orangeSpiral.svg": 43577,
	"./block/pinkScribble.svg": 32864,
	"./block/pinkSpring.svg": 74699,
	"./block/pinkSpringWire.svg": 63012,
	"./block/purpleBit.svg": 48055,
	"./block/purpleLine.svg": 73280,
	"./block/purpleSBend.svg": 13648,
	"./block/redLine.svg": 30999,
	"./block/redScribble.svg": 52113,
	"./block/redScribbleV2.svg": 95941,
	"./block/skyBlueScribble.svg": 38815,
	"./block/violetLine.svg": 34856,
	"./block/yellowCircle.svg": 60628,
	"./block/yellowLine.svg": 32614,
	"./blogauthor/auth-slash.svg": 44460,
	"./blogauthor/auth-spark.svg": 55056,
	"./blogauthor/auth-spiral.svg": 63498,
	"./blurPiece.svg": 23265,
	"./button/hypertext-arrow-right.svg": 2201,
	"./canny/disk.svg": 74797,
	"./canny/machine.svg": 59473,
	"./canny/para.svg": 2628,
	"./canny/smiley.svg": 9527,
	"./canny/ticket.svg": 99402,
	"./caro-button.svg": 71128,
	"./carousel-left.svg": 14174,
	"./carousel-right.svg": 49501,
	"./circle-double.svg": 25496,
	"./close-icon-black.svg": 53950,
	"./close-light.svg": 50673,
	"./community/CommunityLogo.svg": 99374,
	"./community/community_1.svg": 23935,
	"./community/community_2.svg": 44908,
	"./community/community_3.svg": 92269,
	"./community/community_4.svg": 63746,
	"./community/superMspLogo.svg": 76802,
	"./contactus/email-icon.svg": 66379,
	"./contactus/phone.svg": 76071,
	"./contactus/pin-icon.svg": 59004,
	"./cross-red.svg": 26404,
	"./cross-round.svg": 58465,
	"./crossRedLight.svg": 8377,
	"./cta/curvedWhiteArrow.svg": 57254,
	"./curveQuote.svg": 70117,
	"./curveVector.svg": 48094,
	"./customers/cus_page_1.svg": 31891,
	"./customers/cus_page_10.svg": 22729,
	"./customers/cus_page_11.svg": 87864,
	"./customers/cus_page_2.svg": 60992,
	"./customers/cus_page_3.svg": 23793,
	"./customers/cus_page_4.svg": 98446,
	"./customers/cus_page_5.svg": 19551,
	"./customers/cus_page_6.svg": 47852,
	"./customers/cus_page_7.svg": 27565,
	"./customers/cus_page_8.svg": 36442,
	"./customers/cus_page_9.svg": 55499,
	"./customers/pinkSpringWireV2.svg": 67768,
	"./dark-logo-dsk.svg": 50735,
	"./deleteBtn.svg": 4061,
	"./ebook/Done-icon.svg": 87391,
	"./ebook/Vector.svg": 52654,
	"./ebook/bulb.svg": 6958,
	"./ebook/drawer-box.svg": 47784,
	"./ebook/template-vault.svg": 38890,
	"./external-link.svg": 40284,
	"./fb-icon.svg": 9040,
	"./feat-page-downArrow.svg": 37202,
	"./flowchart/arrowDsk1.svg": 8655,
	"./flowchart/arrowDsk2.svg": 45980,
	"./flowchart/arrowDsk3.svg": 35453,
	"./flowchart/colorNo1.svg": 87132,
	"./flowchart/colorNo2.svg": 66159,
	"./flowchart/colorNo3.svg": 3582,
	"./flowchart/colorNo4.svg": 28865,
	"./g2_logo.svg": 67917,
	"./g2_logo_new.svg": 1914,
	"./greenTick.svg": 16996,
	"./greenTickV2.svg": 82220,
	"./halloween/decorationLeaves.svg": 448,
	"./halloween/halloweenQuote.svg": 55345,
	"./halloween/heartIn.svg": 40011,
	"./halloween/horror-stories-logo.svg": 23918,
	"./halloween/scaryLogo.svg": 80147,
	"./happyHoliday2024.svg": 83892,
	"./home/Download.svg": 16762,
	"./home/Ellipse-dark.svg": 4233,
	"./home/Ellipse-light.svg": 19999,
	"./home/Headphones.svg": 31927,
	"./home/New-new.svg": 42341,
	"./home/Star.svg": 69538,
	"./home/blog-decor.svg": 60882,
	"./home/blue-line-one.svg": 32270,
	"./home/book-open.svg": 2022,
	"./home/doodle1.svg": 3690,
	"./home/doodle2.svg": 48089,
	"./home/doodle3.svg": 40168,
	"./home/doodle4.svg": 59975,
	"./home/doodle5.svg": 72854,
	"./home/highlight.svg": 52614,
	"./home/integration-line.svg": 37159,
	"./home/play-button-white.svg": 67617,
	"./home/play-button.svg": 47325,
	"./home/quote-home.svg": 98874,
	"./home/rightArrBlack.svg": 12922,
	"./home/spsLogoSmall.svg": 20580,
	"./home/square-grunge.svg": 16826,
	"./home/stroke-grunge.svg": 55077,
	"./home/yellow-line-new.svg": 99940,
	"./home/yellow-line-one.svg": 16478,
	"./hyperlink-icon.svg": 91526,
	"./hypertext-arrow-right.svg": 74068,
	"./infoIcon.svg": 73893,
	"./insta-icon.svg": 40975,
	"./leftHand.svg": 23938,
	"./linkedbig.svg": 11281,
	"./ln-icon.svg": 19118,
	"./logo-dark.svg": 69476,
	"./logo-icon.svg": 6755,
	"./logo-light.svg": 61004,
	"./logo.svg": 52607,
	"./marketplace/badgeStar.svg": 24699,
	"./marketplace/plugInOut.svg": 62513,
	"./mspawards/arrow.svg": 65090,
	"./mspawards/calendar.svg": 35501,
	"./mspawards/calendarPink.svg": 46965,
	"./mspawards/isolationMode.svg": 42800,
	"./mspawards/orangeTick.svg": 19678,
	"./nav-arrow-down-white.svg": 52534,
	"./nav-arrow-down.svg": 35866,
	"./nav-arrowdown-mob.svg": 69132,
	"./navigation/Path.svg": 87282,
	"./navigation/ai-star-white.svg": 72110,
	"./navigation/ai-star.svg": 89282,
	"./nominateSuccess.svg": 58820,
	"./opacityLeft.svg": 31654,
	"./opacityLeft2.svg": 74952,
	"./opacityRight.svg": 97381,
	"./opacityRight2.svg": 92781,
	"./partners/Group 271.svg": 28237,
	"./partners/Group 272.svg": 45262,
	"./partners/Group 273.svg": 59903,
	"./partners/Group 274.svg": 42432,
	"./partners/Group 8377.svg": 86772,
	"./partners/Group 8378.svg": 19907,
	"./partners/Group 8379.svg": 5266,
	"./partners/Group 8380.svg": 99938,
	"./partners/Group 8381.svg": 78931,
	"./partners/Group 8382.svg": 8032,
	"./partners/Group 8383.svg": 70833,
	"./partners/Group 8384.svg": 45486,
	"./partners/Group 8386.svg": 94892,
	"./partners/Group 8387.svg": 74605,
	"./partners/Group 8391.svg": 26012,
	"./partners/Group 8392.svg": 28335,
	"./partners/Group 8393.svg": 91934,
	"./partners/Group 8394.svg": 9313,
	"./partners/Group 8395.svg": 18192,
	"./partners/Group 8396.svg": 7587,
	"./partners/Group 8397.svg": 20626,
	"./pattern/larrowp-spark.svg": 22580,
	"./pattern/lcircleb-circle.svg": 83006,
	"./pattern/lcirclep-circle.svg": 69456,
	"./pattern/ldev2p.svg": 38008,
	"./pattern/ldevp-dev.svg": 48896,
	"./pattern/rarrowp-large.svg": 17436,
	"./pattern/rcirclep-rcircle.svg": 69220,
	"./pattern/rdatap-blue.svg": 44810,
	"./pattern/rdatap-document.svg": 28105,
	"./pattern/rharddisc.svg": 23267,
	"./pattern/rharddisc2p.svg": 91393,
	"./pattern/rslashp-rslash.svg": 44898,
	"./pattern/wire.svg": 97400,
	"./philosophy-bullet.svg": 64340,
	"./philosophy/star.svg": 90534,
	"./pinkQuoteSmall.svg": 28579,
	"./pinkStar.svg": 92130,
	"./playPause.svg": 290,
	"./play_btn_square.svg": 49777,
	"./polygon.svg": 7012,
	"./popper-big.svg": 17965,
	"./pricing/data-green.svg": 38813,
	"./pricing/harddisk-yellow.svg": 48056,
	"./pricing/pricing-not.svg": 66575,
	"./pricing/pricing-yes.svg": 76221,
	"./pricing/spiral-black-hb.svg": 51309,
	"./pricing/spiral-black-ht.svg": 80931,
	"./pricing/tooltip.svg": 5500,
	"./quote.svg": 92250,
	"./quotes.svg": 63909,
	"./reddit-colored.svg": 82043,
	"./refer-a-friend/refer_svg_1.svg": 41967,
	"./refer-a-friend/refer_svg_2.svg": 62940,
	"./rightArrTilt.svg": 93508,
	"./rightHand.svg": 99115,
	"./rightSlantingArr.svg": 57857,
	"./social/Applepodcast.svg": 84166,
	"./social/Google.svg": 96979,
	"./social/RSS.svg": 25834,
	"./social/Spotify.svg": 87236,
	"./social/Stitcher.svg": 94576,
	"./social/Youtube.svg": 61989,
	"./social/iconFacebookNew.svg": 39945,
	"./social/iconRedditNew.svg": 93001,
	"./social/iconTwitterNew.svg": 6020,
	"./social/iconWhatsappNew.svg": 57783,
	"./social/iconfacebook.svg": 82233,
	"./social/iconinstagram.svg": 28043,
	"./social/iconlinkedin.svg": 23671,
	"./social/iconmail.svg": 88744,
	"./social/iconmedium.svg": 52464,
	"./social/iconreddit.svg": 68057,
	"./social/iconrss.svg": 6055,
	"./social/icontwitter.svg": 78390,
	"./social/iconwhatsapp.svg": 75659,
	"./social/linkicon.svg": 23957,
	"./spsLogoDarkNew.svg": 21695,
	"./spsLogoLightNew.svg": 96809,
	"./star.svg": 19366,
	"./superops_chat.svg": 1834,
	"./superops_folder.svg": 53644,
	"./superops_puzzle.svg": 67772,
	"./superops_swissknife.svg": 82412,
	"./superpod/msp-show.svg": 25845,
	"./superpod/playicon-pink-small.svg": 22597,
	"./superpod/playicon-pink.svg": 19687,
	"./superpod/superpod-logo.svg": 19027,
	"./thankyou-love.svg": 58796,
	"./tick-green.svg": 46595,
	"./tick-round.svg": 47554,
	"./triangle.svg": 5350,
	"./twitter-icon.svg": 27171,
	"./twitterBig.svg": 78867,
	"./upload-file-success.svg": 97502,
	"./vs-icon.svg": 88011,
	"./webinar-bell.svg": 81430,
	"./webinar/calendar.svg": 67737,
	"./webinar/clock.svg": 50907,
	"./webinar/location.svg": 47078,
	"./winnerLeaves.svg": 20871,
	"./x-icon.svg": 49460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22050;